module.exports = __webpack_public_path__ + "static/media/CAM_11.1bc2d037.png";